import React from 'react';
import { useSession } from 'next-auth/react';
import { ASSET_TYPE } from '../../../react-three-components/sceneAsset';
import ObjectPosAudioProps from './objectPosAudioProps';
import ObjectPortalProps from './objectPortalProps';
import ChangeTextureComponent from './changeTextureComponent';
import VideoEditor from './videoEditor';

export default function ObjectProperties({
  assetType,
  selectedModel,
  selectedModelProps,
  dispatchChangeModels,
  setSelectedModelProps,
}) {
  const { data: session } = useSession();
  const threeObj = selectedModel.props.asset.ref.current;
  const userId = session?.user?.id || '';

  switch (assetType) {
    case ASSET_TYPE.MISC.LIGHT:
      return null;
    case ASSET_TYPE.MISC.POSITIONAL_AUDIO:
      let audioElem = threeObj.getObjectByProperty('type', 'Audio');

      if (!audioElem) {
        audioElem = threeObj.getObjectByProperty('name', 'PositionalAudioElem');
      }

      if (!audioElem) {
        threeObj.traverse((child) => {
          if (child.type === 'Audio' || child.isAudio) {
            audioElem = child;
          }
        });
      }

      if (audioElem) {
        return <ObjectPosAudioProps audio={audioElem} />;
      }

      return <></>;

    case ASSET_TYPE.GLTF.OTHER:
      if (selectedModel?.props?.asset?.isPortal) {
        return <ObjectPortalProps portal={selectedModel} userId={userId} />;
      }
      return null;

    case ASSET_TYPE.PRIMITIVE_TEXTURE.IMAGE_PLANE:
      return <></>;
    case ASSET_TYPE.PRIMITIVE_TEXTURE.SCREEN_SHARE:
      return <></>;
    case ASSET_TYPE.PRIMITIVE_TEXTURE.VIDEO_PLANE:
      return (
        <VideoEditor
          selectedModel={selectedModel}
          selectedModelProps={selectedModelProps}
          dispatchChangeModels={dispatchChangeModels}
          setSelectedModelProps={setSelectedModelProps}
        />
      );
  }

  return <></>;
}
